module.exports = __webpack_public_path__ + "keep_rewards_icons.webp";